import React from "react";
import { Breadcrumbs as MUIBreadcrumbs, Link, Typography } from "@material-ui/core";
import { withRouter } from "react-router-dom";

const Breadcrumbs = props => {
  const { history, location: { pathname } } = props;
  const rawarr = pathname.split("/").filter(x => x);
  if (rawarr[3] === "Clone") {
    rawarr.splice(2, 1);
  }
  let pathnames = [];
  pathnames = rawarr.slice(0, 3);
  return (
    <>
    {pathnames.length > 1 &&
      <MUIBreadcrumbs aria-label="breadcrumb" style={{backgroundColor:"rgb(243, 244, 245)", paddingLeft:"40px", paddingTop:"10px", cursor:"pointer"}}>
      {pathnames.map((name, index) => {
        const routeTo = `/${pathnames.slice(0, index + 1).join("/")}`;
        const isLast = index === pathnames.length - 1;
        return isLast ? (
          <Typography key={name}>{name}</Typography>
        ) : (
            <Link key={name} onClick={() => history.push(routeTo)}>
              {name}
            </Link>
          );
      })}

    </MUIBreadcrumbs>
    }
    </>
  );
};

export default withRouter(Breadcrumbs);
